import { useCallback, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { Briefcase, Check, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { fmtFecha } from "@/lib/format";
import { useEmpresa } from "@/hooks/useEmpresa";
import PageHeader from "@/components/PageHeader";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

export default function MisProyectos() {
  const { empresa, cargando: cargandoEmpresa } = useEmpresa();
  const [items, setItems] = useState([]);
  const [cargando, setCargando] = useState(true);

  const cargar = useCallback(async () => {
    try {
      const { data } = await api.get("/proyectos/mis/asignaciones");
      setItems(data.items || []);
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setCargando(false);
    }
  }, []);

  useEffect(() => { cargar(); }, [cargar]);

  const confirmar = async (id) => {
    try {
      await api.post(`/proyectos/asignaciones/${id}/confirmar`);
      toast.success("Horario del proyecto confirmado");
      cargar();
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };

  if (!cargandoEmpresa && empresa && !empresa.gestionar_proyectos) {
    return <Navigate to="/fichar" replace />;
  }

  return (
    <div className="space-y-5">
      <PageHeader
        icon={Briefcase}
        title="Mis proyectos"
        subtitle="Proyectos en los que estás asignado"
        gradient="from-violet-600 via-purple-600 to-fuchsia-600"
      />

      {cargando ? (
        <div className="flex justify-center py-16">
          <Loader2 className="h-8 w-8 animate-spin text-violet-500" />
        </div>
      ) : items.length === 0 ? (
        <p className="rounded-xl border border-dashed border-violet-100 py-12 text-center text-sm text-zinc-500">
          No tienes proyectos asignados.
        </p>
      ) : (
        <div className="space-y-3">
          {items.map((a) => (
            <div key={a.id} className="rounded-xl border border-violet-100 bg-white p-4 shadow-sm">
              <div className="flex items-start justify-between gap-3">
                <div>
                  <p className="font-medium text-zinc-900">{a.proyecto_nombre}</p>
                  <p className="text-xs text-zinc-500">
                    {fmtFecha(a.fecha_inicio)}{a.fecha_fin ? ` → ${fmtFecha(a.fecha_fin)}` : " → Indefinido"}
                  </p>
                  <Badge variant="outline" className="mt-2">{a.carga_pct}% carga</Badge>
                  {a.estado === "pendiente_confirmacion" && (
                    <Badge className="ml-2 mt-2 bg-amber-100 text-amber-800">Confirma horario</Badge>
                  )}
                </div>
                {a.estado === "pendiente_confirmacion" && (
                  <Button size="sm" className="gap-1.5" onClick={() => confirmar(a.id)}>
                    <Check className="h-4 w-4" />
                    Confirmar
                  </Button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
